var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"translations-component"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('list',{ref:"localeList",attrs:{"localeKey":_vm.locale}})],1),_vm._v(" "),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }